/**
 * Shopify Affiliate Redirect Implementation
 * For website migration - Redirect affiliate ref links to bg_ref format
 * Created: 2026-02-08
 * Updated: 2026-03-15 - Added affiliate links redirects
 * Updated: 2026-03-27 - Removed URL redirects (moved to Shopify CSV import)
 * Usage: Add to Shopify theme's theme.liquid file
 */

(function() {
  'use strict';

  // Get current page path and full URL
  var currentPath = window.location.pathname;
  var currentSearch = window.location.search;
  var hostname = window.location.hostname;

  // Affiliate links ref to bg_ref mapping
  var affiliateMap = {
    '512': 'og1OFRncnd',
    '714': 'og1OFRncnd',
    '517': 'OSDFAtKYZc',
    '745': '16pyLiL8mC',
    '757': 'GQYo580Y7I',
    '743': '4JitfNg9iK',
    '531': 'rOiSUwavrH',
    '756': 'oTapB0pfqs',
    '533': 'DYd6PuMMGm',
    '509': 'uxPcKPhhT7',
    '545': 'CLLXKLsl66',
    '7': 'hPUI8thVh2',
    '761': 'lqTLPRu9g6',
    '763': 'u5GdY18GB8'
  };
  
  /**
   * Execute affiliate redirect check
   */
  function checkAndRedirect() {

    // ============================================================
    // AFFILIATE LINKS CHECK
    // ============================================================

    // Check path+query parameter match for affiliate links
    // Compatible with both formats: /?ref=XXX&AOUSA and /?ref=XXX
    if (currentSearch && currentSearch.indexOf('ref=') !== -1) {
      // Extract ref value from query string
      var refMatch = currentSearch.match(/[?&]ref=(\d+)/);
      if (refMatch) {
        var refValue = refMatch[1];
        // Check if this ref exists in affiliate map
        if (affiliateMap[refValue]) {
          var newUrl = 'https://www.arkenopticsusa.com?bg_ref=' + affiliateMap[refValue];
          performRedirect(newUrl);
          return;
        }
      }
    }
    
    // Additional check: if current domain is arkenopticsusa.com (without www) 
    // and homepage with ref parameter
    if (hostname.indexOf('arkenopticsusa.com') !== -1 && 
        hostname.indexOf('www.') === -1 && 
        currentPath === '/' && 
        currentSearch && 
        currentSearch.indexOf('ref=') !== -1) {
      
      var refMatch = currentSearch.match(/[?&]ref=(\d+)/);
      if (refMatch) {
        var refValue = refMatch[1];
        if (affiliateMap[refValue]) {
          var newUrl = 'https://www.arkenopticsusa.com?bg_ref=' + affiliateMap[refValue];
          performRedirect(newUrl);
          return;
        }
      }
    }
  }
  
  /**
   * Perform redirect
   * @param {string} newUrl - New URL
   */
  function performRedirect(newUrl) {
    if (window.console && console.log) {
      console.log('[Affiliate Redirect] ' + currentPath + currentSearch + ' → ' + newUrl);
    }
    window.location.replace(newUrl);
  }
  
  // Execute redirect check immediately after page load
  checkAndRedirect();
  
})();